//#region src/lib/utils/clientVersionString.ts
var e = (e) => {
	let t = process.env.NX_BUILD_NUMBER ? `+${process.env.NX_BUILD_NUMBER}` : "";
	return `${e.buildMajor}.${e.buildMinor}.${e.buildRevision}${t}`;
};
//#endregion
export { e as clientVersionString };
